// extracted by mini-css-extract-plugin
export var actions = "_17-0";
export var actionsContainer = "_17-6";
export var border = "_17-1";
export var childFullHeight = "_17-d";
export var collapse = "_17-2";
export var content = "_17-8";
export var contentChild = "_17-c";
export var fullscreen = "_17-a";
export var headerContainer = "_17-3";
export var headerRow = "_17-5";
export var hidePadding = "_17-9";
export var noScrollX = "_17-e";
export var noScrollY = "_17-f";
export var optOutTopPadding = "_17-b";
export var pagePadding = "_17-7";
export var profile = "_17-g";
export var profileContainer = "_17-h";
export var profileImage = "_17-i";
export var profileMain = "_17-j";
export var profileSubtitle = "_17-l";
export var profileTitle = "_17-k";
export var tabsWrapper = "_17-4";
export var title = "_17-m";